import { VisualPlanEditorContent } from 'app/frontend/base/pages/TeamDashboard/subpages/TeamPlans/components/visual_plans/VisualPlanEditor'

const UserVisualPlanEditor = () => {
  return (
    <VisualPlanEditorContent
      owner={{ ownerType: 'user' }}
      basePath='/profile/plans'
      canEdit={true}
      showViewers={false}
    />
  )
}

export default UserVisualPlanEditor
